define(function (require) {


    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var TableHeaderViewController = require('web-agent-framework/TableHeaderViewController');
    var TableViewController = require('web-agent-framework/TableViewController');
    var PagingViewController = require('web-agent-viewControllers/PagingViewController');
    var TableSearchViewController = require('web-agent-viewControllers/TableSearchViewController');
    var TableActionsViewController = require('web-agent-viewControllers/TableActionsViewController');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');
    var GenerateTokenViewController = require('web-agent-viewControllers/GenerateTokenViewController');
    var FilterFullTableViewController = require('web-agent-components/FilterFullTableViewController');

    var BaseTableViewController = ViewController.extend({
        ControllerName: "BaseTableViewController",
        applicationType: "BaseTableViewController",
        DEFAULT_LOADING_TIMEOUT_LIMIT: 30000,

    LPViewMap : {
        tableMainContainer : ".lpview_base_table_container",
        tableAreaContainer : ".lpview_table_area_container",
        tableContainer : ".lpview_table_container",
        tableHead : ".lpview_table_thead",
        tableBody : ".lpview_table_tbody",
        tableFooter : ".lpview_table_footer",
        messagesContainer : '.lpview_message_container',
        messagesText : ".lpview_message_text",
        searchContainer : '.lpView_table_search_container',
        actionsContainer : '.lpview_table_actions_container',
        headerFilterButton: ".lpview_filterButton"
    },

    LPClassesMap : {
        tableDescription : 'table_description',
        tableDescriptionContainer : '.table_description_container',
        tableActionsButton: 'table_actions_button_shown',
        loading : 'loading',
        empty : 'empty',
        error : 'error',
        emptyFiltered : 'emptyFiltered',
        filterContainer : '.lpView_table_filter_container',
        filterShow: 'filter_show',
        filterOn: 'filter_on',
        filterIcon: 'lpview_full_table_filter_icon'
    },

        LPFilterStatus: {
            disabled: "disabled"
        },

        LPTranslationsText: {
            disableFilterTooltip: "disable_filter_tooltip"
        },

        LPIconStatus: {
            on: "on",
            off: "off",
            show: "show",
            hide: "hide"
        },

        initialize: function (constructorData) {
            this.LPQueryData = {};
            this.isTableFocued = false;
            constructorData = this.configuration;
            this.modifyGlobalData(constructorData);
            this.templateFile = constructorData.templateFile || "LP_base_table.html";
            this.textsPrefix = constructorData.textsPrefix ? constructorData.textsPrefix + "_" : "";
            this.tableDescription = constructorData.textsPrefix ? this.textsPrefix + this.LPClassesMap.tableDescription : "";
            this.tableName = constructorData.tableName || this.applicationType + "_" + new Date().getTime();
            this.tableClass = constructorData.tableClass || this.applicationType;
            this.tableItemsStateModelPath = constructorData.tableRootModelPath + ".state";
            this.tableItemsDataModelPath = constructorData.tableRootModelPath + ".data";
            this.tableItemsArrayModelPath = constructorData.tableRootModelPath + ".array";
            this.tableItemsCountModelPath = constructorData.tableRootModelPath + ".count";
            this.updateQueryCallback = constructorData.updateQueryCallback;
            this.emptyEndTableMessageTag = constructorData.emptyEndTableMessageTag;
            this.showPagingOnEmptyList = constructorData.showPagingOnEmptyList;
            this.context = constructorData.context;
            this.loadingTimeoutLimit = constructorData.loadingTimeout || this.DEFAULT_LOADING_TIMEOUT_LIMIT;
            this.connectionPanelVisible = agentLEManager.getLEAttributeValue("LEConnection", "isOpened");
            this.focusLevel = 1;
            this.filterStatusEnable = constructorData.filterStatusEnable;
            this.initializeView();
            this.addClass(this.view, this.tableClass);
            this.updatePollingWhenVisibleChange();

            if (constructorData.tableHead) {
                this.addGlobalData(constructorData.globalData, constructorData.tableHead);
                constructorData.tableHead.view = this.getFirstElement(this.LPViewMap.tableHead);
                constructorData.tableHead.tableContainer = this.getFirstElement(this.LPViewMap.tableMainContainer);
                this.tableHead = new TableHeaderViewController(constructorData.tableHead);
                this.addViewController(this.tableHead);
            }
            if (constructorData.tableBody) {
                this.addGlobalData(constructorData.globalData, constructorData.tableBody);
                constructorData.tableBody.rowsPlaceholder = this.LPViewMap.tableBody;
                constructorData.tableBody.view = this.getFirstElement(this.LPViewMap.tableContainer);
                constructorData.tableBody.dataBinder = constructorData.tableBody.dataBinder || this.baseTableBodyDataBinder;
                constructorData.tableBody.modelPath = this.tableItemsArrayModelPath;
                constructorData.focusedView = this.view;
                this.tableBody = new TableViewController(constructorData.tableBody);
                this.addViewController(this.tableBody);
            }
            if (constructorData.paging) {
                this.addGlobalData(constructorData.globalData, constructorData.paging);
                constructorData.paging.tableItemsCountModelPath = this.tableItemsCountModelPath;
                this.paging = new PagingViewController(constructorData.paging);
                this.addViewController({viewController: this.paging, target: this.LPViewMap.tableFooter});
            }
            if (constructorData.widgets && constructorData.widgets.widgetsManager && constructorData.widgets.widgetsManagerData) {
                this.addGlobalData(constructorData.globalData, constructorData.widgets.widgetsManagerData);
                constructorData.widgets.widgetsManagerData.hidden = true;
                if(typeof constructorData.widgets.widgetsManagerData.autoHideButtonsToolbar === 'undefined')
                {
                    constructorData.widgets.widgetsManagerData.autoHideButtonsToolbar = true;
                }
                constructorData.widgets.widgetsManagerData.templateFile = 'LP_visitor_list_widgets.html';
                this.widgetsManager = new constructorData.widgets.widgetsManager(constructorData.widgets.widgetsManagerData);
                this.addViewController({viewController: this.widgetsManager, target: this.LPViewMap.tableMainContainer});
            }
            if(constructorData.tableSearch){
                this.addGlobalData(constructorData.globalData, constructorData.tableSearch);
                constructorData.tableSearch.filterName = "tableSearch";
                this.tableSearch = new TableSearchViewController(constructorData.tableSearch);
                this.tableSearch.searchInput.setFilter(this.modelController.getSessionData({name: this.tableName, key: "searchArea"}));
                this.addViewController({viewController : this.tableSearch, target: this.LPViewMap.searchContainer});
            }
            if(constructorData.tableActions){
                this.addGlobalData(constructorData.globalData, constructorData.tableActions);
                this.tableActions = new TableActionsViewController(constructorData.tableActions);
                this.addViewController({viewController : this.tableActions, target: this.LPViewMap.actionsContainer});
            }
            if(constructorData.tableGenerateToken){
                this.addGlobalData(constructorData.globalData, constructorData.tableGenerateToken);
                this.tableGenerateToken = new GenerateTokenViewController(constructorData.tableGenerateToken);
                this.addViewController({viewController: this.tableGenerateToken,target: this.LPClassesMap.tableDescriptionContainer, hidden: true});
            }
            if (constructorData.tableFilters) {
                this.addGlobalData(constructorData.globalData, constructorData.tableFilters);
                this.tableFilters = new FilterFullTableViewController({
                    filterFields: constructorData.tableFilters,
                    tableName: constructorData.tableName,
                    filterName: constructorData.tableFilters.filterName,
                    iconCallback: this.setFilterIcon,
                    iconContext: this
                });
                this.tableFilters.setFilter(this.modelController.lastQuery[this.filterName]);
                this.addViewController({viewController : this.tableFilters, target: this.LPClassesMap.tableDescriptionContainer, hidden: true});
            }
            this.showTableLoading();
        },

        events: function () {
            this.bindModel({modelPath : this.tableItemsStateModelPath, callback: this.handleTableStatusChanged});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_FILTER_OPENED, callback: this.onFilterOpened});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_FILTER_CLOSED, callback: this.onFilterClosed});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_WIDGETS_OPENED, callback: this.onWidgetsOpened});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_WIDGETS_CLOSED, callback: this.onWidgetsClosed});
            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.TABLE_OFFLINE_ORB_OPENED, callback: this.onOfflineOrbOpened});
            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.TABLE_OFFLINE_ORB_CLOSED, callback: this.onOfflineOrbClosed});
            agentLEManager.bindToLEValue("change:LEConnection.isOpened", this.onConnectionPanelChanged.bind(this));
            agentLEManager.onLEEvent("focusStatus:change", this.changeFocus, this);
            this.bindViewEvent({selector: this.LPClassesMap.filterContainer, DOMEvent: "click", callback: this.filterClicked});

        },

        render: function () {
        }
    });

    BaseTableViewController.prototype.initializeView = function () {
        var tableTemplate = require('web-agent-templates/' + this.templateFile);
        // var tableTemplate = lpUtils.loadResource(this.templateFile);
        var textInjection = {
            tableDescription: '{{' + this.tableDescription + '}}'
        };
        tableTemplate = this.injectTextDefaults(tableTemplate, textInjection);
        this.view = this.createView({template : tableTemplate, wrapWithDiv: false});
    };

    BaseTableViewController.prototype.modifyGlobalData = function (constructorData) {
        if (constructorData) {
            constructorData.globalData = constructorData.globalData || {};
            constructorData.globalData.updateQueryCallback = this.baseUpdateQuery;
            constructorData.globalData.notifyFilterOpenedCallback = this.notifyFilterOpened;
            constructorData.globalData.notifyFilterClosedCallback = this.notifyFilterClosed;
            constructorData.globalData.context = this;
            constructorData.globalData.tableRootModelPath = constructorData.tableRootModelPath;
            constructorData.globalData.tableLastSentQueryModelPath = constructorData.tableRootModelPath + ".lastQuery";
            constructorData.globalData.tableItemsStateModelPath = constructorData.tableRootModelPath + ".state";
        }
    };

    BaseTableViewController.prototype.addGlobalData = function (globalData, subComponentData) {
        if (globalData && subComponentData) {
            for (var key in globalData) {
                if (globalData.hasOwnProperty(key) && !subComponentData[key]) {
                    subComponentData[key] = globalData[key];
                }
            }
        }
    };

    BaseTableViewController.prototype.baseUpdateQuery = function (data) {
        this.updateQuery(data);
        this.showTableLoading();
        // If we have a paging component in the table and we identify that the updateQuery is coming
        // from a component that changed the sorting, filtering or search query for the table, we request to go to the start page as part of this request.
        if (this.paging && data && data.startPage) {
            this.paging.getPage(this.paging.getStartPage());
        } else {
            this.updateQueryCallback.call(this.context, this.LPQueryData);
        }
    };

    BaseTableViewController.prototype.updateQuery = function (data) {
        if (data) {
            for (var key in data) {
                if (data.hasOwnProperty(key) && key !== "startPage") {
                    this.LPQueryData[key] = data[key];
                }
            }
        }
    };

    BaseTableViewController.prototype.handleTableStatusChanged = function (data) {
        if (data && data.newValue) {
            if (data.newValue.error) {
                this.showTableError();
            } else if (data.newValue.unloaded || data.newValue.status === "fetching") {
                this.showTableLoading();
            } else {
                this.showTableContent(data.newValue);
            }
        }
    };

    BaseTableViewController.prototype.showTableContent = function (data) {
        this.removeClass(this.LPViewMap.messagesContainer, [this.LPClassesMap.error, this.LPClassesMap.loading]);
        this.clearLoadingTimeout();
        if (data) {
            if (data.itemsCount) {
                this.getFirstElement(this.LPViewMap.messagesText).innerHTML = "";
                this.removeClass(this.LPViewMap.messagesContainer, this.LPClassesMap.empty);
                if (this.paging) {
                    this.paging.lpShow();
                }
                this.focusTableBody();
            } else {
                var emptyTableMessageTag;
                if (this.emptyEndTableMessageTag && this.paging) {
                    emptyTableMessageTag = this.paging.count > 0 ? this.emptyEndTableMessageTag : this.LPClassesMap.empty;
                } else {
                    var tableFiltered = this.tableHead ? this.tableHead.isTableFilterSet() : false;
                    emptyTableMessageTag = tableFiltered ? this.LPClassesMap.emptyFiltered : this.LPClassesMap.empty;
                }
                this.getFirstElement(this.LPViewMap.messagesText).innerHTML = this.translate(this.textsPrefix + emptyTableMessageTag);
                this.addClass(this.LPViewMap.messagesContainer, this.LPClassesMap.empty);
                if (this.showPagingOnEmptyList && this.paging) {
                    this.paging.lpShow();
                }
            }
        }
    };

    BaseTableViewController.prototype.showTableLoading = function () {
        if (this.widgetsManager) {
            this.widgetsManager.closeWidgetsArea();
        }
        this.removeClass(this.LPViewMap.messagesContainer, [this.LPClassesMap.empty, this.LPClassesMap.error]);
        this.addClass(this.LPViewMap.messagesContainer, this.LPClassesMap.loading);
        if (this.paging) {
            this.paging.lpHide();
        }
        this.setLoadingTimeout();
    };

    BaseTableViewController.prototype.showTableError = function () {
        if (this.widgetsManager) {
            this.widgetsManager.closeWidgetsArea();
        }
        if (this.paging) {
            this.paging.lpHide();
        }
        this.getFirstElement(this.LPViewMap.messagesText).innerHTML = this.translate(this.textsPrefix + this.LPClassesMap.error);
        this.removeClass(this.LPViewMap.messagesContainer, [this.LPClassesMap.empty, this.LPClassesMap.loading]);
        this.addClass(this.LPViewMap.messagesContainer, this.LPClassesMap.error);
    };

    BaseTableViewController.prototype.baseTableBodyDataBinder = {
        modelDataChanged: function () {
            if (this.widgetsManager) {
                var currentItemExist = !!this.modelController.getModelParam(this.tableItemsDataModelPath + '.' + this.widgetsManager.selectedItemId);
                if (!currentItemExist) {
                    this.widgetsManager.closeWidgetsArea();
                }
            }
        },
        operationCanceled: function () {
            if (this.widgetsManager) {
                this.widgetsManager.closeWidgetsArea();
            }
        },
        rowSelected: function (data) {
            if (this.widgetsManager) {
                if (this.widgetsManager.visible) {//ElaA:: do NOT protect it with Id comparison -
                    // it will cause a bug that shows a wrong info if the user navigate too fast between 2 rows
                    var participantInfo = data.participantInfo || data;
                    this.widgetsManager.updateSelectedItemData(participantInfo);
                }
            }
        },
        rowClicked: function (data) {
            if (this.widgetsManager) {
                var participantInfo = data.rowData.participantInfo || data.rowData;
                if (this.widgetsManager.visible) {

                    if (this.widgetsManager.selectedItemId !== lpUtils.getPropertyValueByPath(participantInfo, this.widgetsManager.itemIdTag)) { // update only if a new visitor was selected
                        this.widgetsManager.updateSelectedItemData(participantInfo, false);
                    } else {
                        this.widgetsManager.closeWidgetsArea();
                    }
                } else {
                    this.widgetsManager.lpShow();
                    this.widgetsManager.updateSelectedItemData(participantInfo, false);
                }
            }
        }
    };

// stop/start polling on the current table when becoming invisible/visible (on switching to/from other tab, e.g. CAMPAIGNS or USERS)
    BaseTableViewController.prototype.updatePollingWhenVisibleChange = function () {
        var context = this;
        agentLEManager.bindToLEValue('change:LEWebAgent.isVisible', function (model, data) {
            if(context && context.isTableFocued) {
                if (data) {
                    context.modelController.startPolling();
                }
                else {
                    context.modelController.stopPolling();
                    context.isTableFocued = true;
                }
            }
        });
    };

    BaseTableViewController.prototype.focusTable = function (showLoading) {
        if (showLoading) {
            this.showTableLoading();
        }
        this.isTableFocued = true;
        this.modelController.startPolling();
    };

    BaseTableViewController.prototype.blurTable = function () {
        if (this.widgetsManager) {
            this.widgetsManager.closeWidgetsArea();
        }
        this.isTableFocued = false;
        this.modelController.stopPolling();

        if(this.tableFilters) {
            this.tableFilters.cancel();
        }
        if(this.tableGenerateToken) {
                this.tableGenerateToken.hideDialog();
            }};

    BaseTableViewController.prototype.setLoadingTimeout = function () {
        this.clearLoadingTimeout();
        this.isLoading = true;
        var that = this;
        this.loadingTimeout = setTimeout(function() {
            if (that.isLoading) {
                that.showTableError();
                that.isLoading = false;
            }
        }, this.loadingTimeoutLimit);
    };

    BaseTableViewController.prototype.clearLoadingTimeout = function () {
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
            this.isLoading = false;
        }
    };

    BaseTableViewController.prototype.notifyFilterOpened = function (filterName) {
        this.viewEventsHandler.fireEvent({
            appName: this.tableName,
            UIEvent: this.viewEventsHandler.eventType.TABLE_FILTER_OPENED,
            eventData: {
                filterName: filterName
            }
        });
    };

    BaseTableViewController.prototype.notifyFilterClosed = function () {
        this.viewEventsHandler.fireEvent({
            appName: this.tableName,
            UIEvent: this.viewEventsHandler.eventType.TABLE_FILTER_CLOSED
        });
    };

    BaseTableViewController.prototype.onFilterOpened = function () {
        this.filterVisible = true;
    };

    BaseTableViewController.prototype.onFilterClosed = function () {
        this.filterVisible = false;
        this.focusTableBody();
    };

    BaseTableViewController.prototype.onWidgetsOpened = function () {
        this.widgetsVisible = true;
    };

    BaseTableViewController.prototype.onWidgetsClosed = function () {
        this.widgetsVisible = false;
        this.focusTableBody();
    };
    BaseTableViewController.prototype.onOfflineOrbOpened = function () {
        this.OfflineOrbVisible = true;
    };

    BaseTableViewController.prototype.onOfflineOrbClosed = function () {
        this.OfflineOrbVisible = false;
        this.focusTableBody();
    };

    BaseTableViewController.prototype.onConnectionPanelChanged = function (model, data) {
        this.connectionPanelVisible = data;
    };

    BaseTableViewController.prototype.focusTableBody = function () {
        //focus only if the current tab is LE. Table will still update even if not focused.
        var constLE = agentLEManager.getLEConst();
        if (!isFocusedOnInputElement() &&(constLE && constLE.FOCUS_STATUS && this.focusLevel === constLE.FOCUS_STATUS.VISIBLE_FOCUSED) &&
            (this.visible && this.isTableFocued && !this.isComponentVisible())) {
            this.tableBody.focus();
        }
        function isFocusedOnInputElement(){
                return document.activeElement && document.activeElement.type === 'text';
        }
    };

    BaseTableViewController.prototype.changeFocus = function (data) {
        if (typeof data !== 'undefined') {
            this.focusLevel = data;
            this.focusTableBody();
        }
    };

    BaseTableViewController.prototype.isComponentVisible = function () {
        return this.widgetsVisible || this.filterVisible || this.connectionPanelVisible || this.OfflineOrbVisible;
    };

    BaseTableViewController.prototype.filterClicked = function () {
        if (this.filterStatusEnable) {
            this.tableFilters.lpShow();
        }
    };

    BaseTableViewController.prototype.setFilterStatus = function(status, filterElement){
        if(status) {
            this.removeClass(filterElement, this.LPFilterStatus.disabled);
            this.removeAttribute(filterElement, "title");
        }
        else {
            this.addClass(filterElement, this.LPFilterStatus.disabled);
            this.setAttribute(filterElement, "title", this.translate(this.textsPrefix + this.LPTranslationsText.disableFilterTooltip));
        }
    };BaseTableViewController.prototype.setHeaderFiltersStatus = function(status) {
        this.tableHead.setFiltersStatus(status);

        var filterButtons = this.getElements(this.LPViewMap.headerFilterButton);
        for (var i = 0; i < filterButtons.length; i++) {
            this.setFilterStatus(status, filterButtons[i]);
        }
    };

    BaseTableViewController.prototype.setFilterIcon = function (iconId, status) {
        switch (status) {
            case this.LPIconStatus.on:
                this.addClass(this.getFirstElement("." + this.LPClassesMap.filterIcon), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.off:
                this.removeClass(this.getFirstElement("." + this.LPClassesMap.filterIcon ), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.show:
                this.addClass(this.getFirstElement("." + this.LPClassesMap.filterIcon), this.LPClassesMap.filterShow); break;
            case this.LPIconStatus.hide:
                this.removeClass(this.getFirstElement("." + this.LPClassesMap.filterIcon), this.LPClassesMap.filterShow); break;
        }
    };

    return BaseTableViewController;

});
